var React = require('react');

function SixPointStar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M131 1.36164L159.605 73.8187L159.775 74.2485L160.217 74.1132L234.701 51.3013L195.887 118.842L195.656 119.243L196.038 119.504L260.313 163.515L183.307 175.28L182.85 175.349L182.884 175.81L188.55 253.503L131.339 200.633L131 200.319L130.661 200.633L73.4504 253.503L79.116 175.81L79.1496 175.349L78.6928 175.28L1.68715 163.515L65.9623 119.504L66.3436 119.243L66.1133 118.842L27.2991 51.3013L101.783 74.1132L102.225 74.2485L102.395 73.8187L131 1.36164Z","stroke":"#3E4F19"}));
}

SixPointStar.defaultProps = {"width":"262","height":"255","viewBox":"0 0 262 255","fill":"none"};

module.exports = SixPointStar;

SixPointStar.default = SixPointStar;
